module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('keep-alive', [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.WinHeight > _vm.WinWidth) ? _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "fixed-bar"
  }, [_c('mu-paper', [_c('mu-bottom-nav', {
    attrs: {
      "value": _vm.bottomNav,
      "shift": ""
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('mu-bottom-nav-item', {
    attrs: {
      "value": _vm.homeIndex,
      "title": "首页",
      "icon": "home",
      "iconClass": "bottomIconColor"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "/home/order",
      "title": "订单",
      "icon": "library_books",
      "iconClass": "bottomIconColor"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "/home/wallet",
      "title": "格林钱包",
      "icon": "credit_card",
      "iconClass": "bottomIconColor"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "/user/Login",
      "title": "我",
      "icon": "account_circle",
      "iconClass": "bottomIconColor"
    }
  })], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47aa013c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/home.vue
// module id = 1487
// module chunks = 18